import React, { useRef, useState } from "react";
import './Book.scss';
import { Helmet } from "react-helmet";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import emailjs from 'emailjs-com';
import validator from 'validator';

export default function Book({ UserSession, ZipCode, setZipCode, setUpdateApp, ProjectList, setProjectList, }) {
    // Helpers
    const [Rendder, setRender] = useState(false);
    const [LoadingMatchingText, setLoadingMatchingText] = useState(["Matching with HandyBy", "Find the best match", "Connecting with our pros", "Searching in our data", "Let get your projcet done"]);
    const [LoadingMatchingIndex, setLoadingMatchingIndex] = useState(0);
    const [LoadingProject, setLoadingProject] = useState(false);
    const [ShowHowisWork, setShowHowisWork] = useState(false);
    const [closMenuAnime, setclosMenuAnime] = useState(false);
    const [isListenerEnabled, setIsListenerEnabled] = useState(true);

    var timesRun = 0;
    const navigate = useNavigate();
    const location = useLocation()
    const url = new URL(window.location.href);
    // Project Info
    const [Zipcode, setZipcode] = useState(false);
    const [Address, setAddress] = useState(false);
    const [City, setCity] = useState(false);
    const [FirstName, setFirstName] = useState(false);
    const [LastName, setLastName] = useState(false);
    const [PhoneNumber, setPhoneNumber] = useState(false);
    const [Email, setEmail] = useState(false);
    const [ProjectInfo, setProjectInfo] = useState({
        Service: url.searchParams.get('service') ? String(url.searchParams.get('service').replaceAll('-', ' ')).charAt(0).toUpperCase() + String(url.searchParams.get('service').replaceAll('-', ' ')).slice(1) : 'New Project',
        ZipCode: ZipCode && ZipCode.length ? ZipCode : url.searchParams.get('zipcode') ? url.searchParams.get('zipcode') : '',
        TellUsAboutYourProject: '',
        TypeOfservices: [],
        TypeOfPropery: "Residential",
        DateForProject: new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).toISOString().substr(0, 10),
        WindowTime: '08:00AM-11:00AM',
        Address: '',
        Apt: '',
        City: '',
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        Email: '',
    });

    async function getFinalIps() {
        try {
            // IPv6
            const responseIpv6 = await fetch('https://api64.ipify.org?format=json');
            const dataIpv6 = await responseIpv6.json();
            // IPv4
            const responseIpv4 = await fetch('https://api.ipify.org?format=json');
            const dataIpv4 = await responseIpv4.json();
            return `
IPv6: ${dataIpv6.ip}
IPv4: ${dataIpv4.ip}
`;
        } catch (error) {
            return 'Unable to fetch IP address.';
        }
    }
    getFinalIps()
    const [ipAddress, setIpAddress] = useState('');

    useEffect(() => {
        getFinalIps().then(ip => setIpAddress(ip));
    }, []);

    useEffect(() => {
        if (typeof window === "undefined") return;
        if (location.pathname !== "/request-service/thanks") return;
        if (url.searchParams.get('spg') !== "o") return;
        if (typeof window.oaiq !== "function") return;
        try {
            window.oaiq("measure", "appointment_scheduled", {
                type: "customer_action",
                amount: 0,
                currency: "USD"
            });
        } catch (e) { }
    }, [location.pathname]);

    const FinalMessage = `
SPG: ${url.searchParams.get('spg') == "g" ? "*Google*" + ` | ${url.searchParams.get('ct') == "demand-gem" ? "*Demand Gem*" : url.searchParams.get('ct') == "search" ? "*Search*" : url.searchParams.get('ct') == "youtube" ? "*YouTube*" : "None"}` : url.searchParams.get('spg') == "f" ? "*Facebook*" : url.searchParams.get('spg') == "m" ? "*Microsoft*" : url.searchParams.get('spg') == "o" ? "*🤖 OpenAI*" : "*Organic*"}
Company name: HandyBy
Lead source: Online Booking
Name: ${ProjectInfo.FirstName + ' ' + ProjectInfo.LastName}
Phone: ${ProjectInfo.PhoneNumber}
Email: ${ProjectInfo.Email}
Address: ${ProjectInfo.Address + ',' + (ProjectInfo.Apt ? ProjectInfo.Apt + ', ' : '') + ProjectInfo.City + ', ' + ProjectInfo.ZipCode}
Property: ${ProjectInfo.TypeOfPropery}
Category: *${ProjectInfo.Service}*
Type: *${ProjectInfo.TypeOfservices}*
Note: ${ProjectInfo.TellUsAboutYourProject}
The Job date: *${ProjectInfo.DateForProject.split("-")[1] + '/' + ProjectInfo.DateForProject.split("-")[2] + '/' + ProjectInfo.DateForProject.split("-")[0] + ' ' + ProjectInfo.WindowTime.split('-')[0]}*
The Job end date: *${ProjectInfo.DateForProject.split("-")[1] + '/' + ProjectInfo.DateForProject.split("-")[2] + '/' + ProjectInfo.DateForProject.split("-")[0] + ' ' + ProjectInfo.WindowTime.split('-')[1]}*

${ipAddress}
`

    const FinalMessageWhatsapp = `
SPG: ${url.searchParams.get('spg') == "g" ? "*Google*" + ` | ${url.searchParams.get('ct') == "demand-gem" ? "*Demand Gem*" : url.searchParams.get('ct') == "search" ? "*Search*" : url.searchParams.get('ct') == "youtube" ? "*YouTube*" : "None"}` : url.searchParams.get('spg') == "f" ? "*Facebook*" : url.searchParams.get('spg') == "m" ? "*Microsoft*" : url.searchParams.get('spg') == "o" ? "*🤖 OpenAI*" : "*Organic*"}
Company name: HandyBy
Lead source: Online Booking
Name: ${ProjectInfo.FirstName + ' ' + ProjectInfo.LastName}
Phone: ${ProjectInfo.PhoneNumber}
Email: ${ProjectInfo.Email}
Address: ${ProjectInfo.Address + ',' + (ProjectInfo.Apt ? ProjectInfo.Apt + ', ' : '') + ProjectInfo.City + ', ' + ProjectInfo.ZipCode}
Property: ${ProjectInfo.TypeOfPropery}
Category: *${ProjectInfo.Service}*
Type: *${ProjectInfo.TypeOfservices}*
Note: ${ProjectInfo.TellUsAboutYourProject}
The Job date: *${ProjectInfo.DateForProject.split("-")[1] + '/' + ProjectInfo.DateForProject.split("-")[2] + '/' + ProjectInfo.DateForProject.split("-")[0] + ' ' + ProjectInfo.WindowTime.split('-')[0]}*
The Job end date: *${ProjectInfo.DateForProject.split("-")[1] + '/' + ProjectInfo.DateForProject.split("-")[2] + '/' + ProjectInfo.DateForProject.split("-")[0] + ' ' + ProjectInfo.WindowTime.split('-')[1]}*
`

    const sentJobToWhatsapp = async () => {
        await fetch("https://api.ultramsg.com/instance120323/messages/chat", {
            method: "POST",
            body: new URLSearchParams({
                token: "ijne8s82zyrs5n7t",
                to: "120363419437168717@g.us",
                body: FinalMessageWhatsapp,
            }),
        });
    }

    function CreateProject(e) {
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        // Create Project
        if (!ProjectInfo.FirstName) { setFirstName(true) } else { setFirstName(false) }
        if (!ProjectInfo.LastName) { setLastName(true) } else { setLastName(false) }
        if (!ProjectInfo.PhoneNumber) { setPhoneNumber(true) } else { setPhoneNumber(false) }
        if (ProjectInfo.Email && validator.isEmail(ProjectInfo.Email)) { setEmail(false) } else { setEmail(true) }
        // Valid Client Info 
        if (ProjectInfo.FirstName && ProjectInfo.LastName && ProjectInfo.PhoneNumber && ProjectInfo.Email && validator.isEmail(ProjectInfo.Email)) {
            setIsListenerEnabled(false)
            intervalFun2(3)
            var interval = setInterval(function () {
                clearInterval(interval);
                // this is probbably set up for facebook to trigger the convertion
                navigate(`/request-service/thanks${url.search}`)

                // and here this is for google convertion
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'thankyouPageView'
                });
            }, 3000);
            // Send Lead To Whatsapp
            sentJobToWhatsapp()

            // Send Lead To Main Email Systems
            emailjs.sendForm('service_fqud6um', 'template_n0o8yjw', e.target, 'QeqW-bXHRNjRmhZ6I')
                .then((result) => {
                    console.log("sent");
                }, (error) => {
                    console.log(error.text);
                });

            // Send Project Verification SMS to User
            (async () => {
                const Message = `
HandyBy: Thank you for booking your ${ProjectInfo.Service} service! Your appointment has been confirmed for ${ProjectInfo.DateForProject.split("-")[1] + '/' + ProjectInfo.DateForProject.split("-")[2] + '/' + ProjectInfo.DateForProject.split("-")[0]} Between ${ProjectInfo.WindowTime} At ${ProjectInfo.Address + ', ' + ProjectInfo.City}

Our verified pro will reach you out 30 Minutes in advance at the appointment day.

- HandyBy.com Team 🏠`;

                const res1 = await fetch('https://api.twilio.com/2010-04-01/Accounts/ACdab44fdbf1b48f60326b707e5986d6f1/Messages.json', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Basic ' + btoa('ACdab44fdbf1b48f60326b707e5986d6f1:791246fdee3b33a59d9d8efa6847fccb')
                    },
                    body: new URLSearchParams({
                        From: '+18886557007',
                        To: `+1${ProjectInfo.PhoneNumber}`,
                        Body: Message
                        // MediaUrl: "https://media.idownloadblog.com/wp-content/uploads/2024/03/Sending-website-URL-on-iMessage-with-and-without-link-preview.png"
                    })
                });
                const data1 = await res1.json()
                // console.log(data1);
            })()

        } else {
            return null
        }

    }

    // Loading Function
    const intervalFun = (seconds) => {
        var interval = setInterval(function () {
            timesRun += 1;
            setLoadingMatchingIndex(timesRun)
            if (timesRun === seconds) {
                scrollRight(7, true)
                clearInterval(interval);
            }
        }, 1000);
    }

    // Loading Function to my projects
    const intervalFun2 = (seconds) => {
        setLoadingProject(true)
        var interval = setInterval(function () {
            timesRun += 1;
            setLoadingMatchingIndex(timesRun)
            if (timesRun === seconds) {
                setProjectList(oldArray => [ProjectInfo, ...oldArray]);
                setRender(a => !a)
                setUpdateApp(a => !a)
                // localStorage.setItem("Project", JSON.stringify(ProjectList))
                scrollRight(8, true)
                clearInterval(interval);
                setLoadingProject(false)
                window.scrollTo(0, 0)
            }
        }, 1000);
    }
    // intervalFun()
    const containerRef = useRef(null);
    const scrollRight = (pages, leftOrReight) => {
        const container = containerRef.current;
        if (container && leftOrReight == true) {
            const scrollAmount = (container.clientWidth * pages);
            container.scrollLeft = scrollAmount;
        } else if (container && leftOrReight == false) {
            const scrollAmount = (container.clientWidth * pages - container.clientWidth - container.clientWidth);
            container.scrollLeft = scrollAmount;
        }
    };
    const containerRef2 = useRef(null);
    // intervalFun()
    const scrollRightHowItWork = (pages, leftOrReight, pixels) => {
        const container = containerRef2.current;
        const numvver = pixels
        if (container && leftOrReight == true) {
            const scrollAmount = (container.clientWidth * pages);
            container.scrollLeft = scrollAmount + parseInt(numvver);
        } else if (container && leftOrReight == false) {
            const scrollAmount = (container.clientWidth * pages - container.clientWidth - container.clientWidth);
            container.scrollLeft = scrollAmount + parseInt(numvver);
        }
    };
    // useEffect
    useEffect(() => {

        // Avoid User Leave The page, Only work last page when user want to leave after service booked
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            const message =
                'Are you sure you want to leave? All provided data will be lost.';
            e.returnValue = message;
            return message;
        };
        if (isListenerEnabled) {
            window.addEventListener('beforeunload', handleBeforeUnload);
        }
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        }
    }, [isListenerEnabled]);



    return (
        <div className="Book">
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>HandyBy - Request {ProjectInfo.Service} Service Near You</title>
                {/* <!-- META --> */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="%PUBLIC_URL%/Logo.png" />
                <meta property="og:url" content={`https://www.handyby.com/request-service`} />
                <meta name="description" content={`Request ${ProjectInfo.Service} Service With HandyBy. Get Matched With A Verified Local Pro And Improve Your Home — Quick, Easy, And Hassle-Free.`} />
                <meta property="og:title" content={`HandyBy - Request ${ProjectInfo.Service} Service`} />
                <meta property="og:description" content={`Enter Your ZIP Code To Get Matched With A Trusted Local ${ProjectInfo.Service} Pro. No Upfront Pricing — Book With Confidence.`} />
                <meta property="og:site_name" content="HandyBy" />
                <meta name="keywords" content={`${ProjectInfo.Service} Cleaning, ${ProjectInfo.Service} Repair, ${ProjectInfo.Service} Service Request, HandyBy, Local ${ProjectInfo.Service} Pros, Home Improvement`} />
            </Helmet>
            <div className="BookHeader">
                <div className="BookHeaderTop">
                    <div className="BookHeaderLogo">
                        <h1 >HandyBy</h1>
                    </div>
                    <div className="BookHeaderMenu">
                        <div className="BookHeaderMenuBox">
                            <h1 style={true ? { "fontWeight": "500" } : null}>1</h1>
                            <h2 style={true ? { "fontWeight": "500" } : null}>Share details</h2>
                        </div>
                        <div className="BookHeaderMenuBox">
                            <h1 style={true ? { "fontWeight": "400" } : null}>2</h1>
                            <h2 style={true ? { "fontWeight": "400", "color": "white" } : null}>Location</h2>
                        </div>
                        <div className="BookHeaderMenuBox">
                            <h1 style={true ? { "fontWeight": "400" } : null}>3</h1>
                            <h2 style={true ? { "fontWeight": "400", "color": "white" } : null}>Request Service</h2>
                        </div>
                    </div>
                </div>
                <div className="BookHeaderBottom">
                    <div className="CategoryNavShape">
                        <span>
                            <img src={require(`../../Images/info.png`)} alt="Chimney Cleaning" />
                            <h1>Requested Service: <span>{ProjectInfo.Service}</span></h1>
                        </span>
                        <span>

                            <h2 onClick={() => setShowHowisWork(true)}>How HandyBy Work?</h2>
                        </span>
                    </div>

                </div>

            </div>
            <div className="BookMain" ref={containerRef}>
                {/* ZipCode */}
                <div className="BookMainPage">
                    <h1>Request Service From Top-Rated <br /> HandyBy's {ProjectInfo.Service} Pros</h1>
                    <div className="BookMainBox">
                        <h2>Enter the location of your project</h2>
                        <div className="BookMainBoxTextInput" style={Zipcode ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                            <img src={require(`../../Images/location.png`)} />
                            <input
                                type="number"
                                inputMode="numeric"
                                placeholder="ZIP Code"
                                defaultValue={ZipCode}
                                value={ZipCode}
                                onChange={(e) => {
                                    ProjectInfo.ZipCode = e.target.value
                                    setZipCode(e.target.value)
                                    setRender(a => !a)
                                    setUpdateApp(a => !a)
                                }}
                            />
                        </div>
                        {Zipcode ? <h6 style={{ "color": "#fc0a0a", "textAlign": "center" }}>Please enter a valid ZIP Code</h6> : null}
                        <div className="BookMainBoxButtons">
                            <button className="BookMainBoxButtonsNext" onClick={() => {
                                ProjectInfo.ZipCode = ZipCode
                                if (ProjectInfo.ZipCode.length == 5) {
                                    scrollRight(1, true)
                                    setZipcode(false)
                                    window.scrollTo(0, 0)
                                } else {
                                    setZipcode(true)
                                }
                            }}>Next</button>
                        </div>
                    </div>
                </div>
                {/* Tell us about your project */}
                <div className="BookMainPage">
                    <h1>Please Tell us a Little About <br /> Your {ProjectInfo.Service} Project.</h1>
                    <div className="BookMainBox">
                        <h2>In a few words, what do you need done?</h2>
                        <div className="BookMainBoxTextQuestion">
                            <textarea
                                name=""
                                id=""
                                placeholder="How can a pro help you? The more details the better - it helps pros provide the most accurate quote! (Optional)"
                                defaultValue={ProjectInfo.TellUsAboutYourProject}
                                onChange={(a) => {
                                    ProjectInfo.TellUsAboutYourProject = a.target.value
                                    setRender(a => !a)

                                }}
                            ></textarea>
                            <h3>{ProjectInfo.TellUsAboutYourProject.length} / 2000</h3>
                        </div>
                        <div className="BookMainBoxButtons">
                            <button className="BookMainBoxButtonsPrevius" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(2, false)
                            }} >Previus</button>
                            <button className="BookMainBoxButtonsNext" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(2, true)
                            }}>{ProjectInfo.TellUsAboutYourProject.length ? "Next" : "Skip"}</button>
                        </div>

                    </div>
                </div>
                {/* What type of service you need? */}
                <div className="BookMainPage">
                    <h1>What Type of service is This?</h1>
                    <div className="BookMainBox">
                        <h2>Tell us what {ProjectInfo.Service} services you need.</h2>
                        <div className="BookMainBoxTextCheck">
                            {/* Home */}
                            <div className="BookMainBoxTextCheckBox"
                                style={ProjectInfo.TypeOfservices.includes("Cleaning") ? { "backgroundColor": "#f3f3f7" } : { "backgroundColor": "white" }}
                                onClick={() => {
                                    if (ProjectInfo.TypeOfservices.includes("Cleaning")) { ProjectInfo.TypeOfservices = ProjectInfo.TypeOfservices.filter(a => a !== "Cleaning") } else { ProjectInfo.TypeOfservices.push("Cleaning") }
                                    console.log(ProjectInfo.TypeOfservices);
                                    setRender(a => !a)
                                }}
                            >
                                <div className="BookMainBoxTextCheckBoxCircle" style={ProjectInfo.TypeOfservices.includes("Cleaning") ? { "backgroundColor": "#0a65fc" } : { "backgroundColor": "white" }}></div>
                                <h3>Cleaning</h3>
                            </div>
                            {/* Bussiness */}
                            <div className="BookMainBoxTextCheckBox"
                                style={ProjectInfo.TypeOfservices.includes("Repair") ? { "backgroundColor": "#f3f3f7" } : { "backgroundColor": "white" }}
                                onClick={() => {
                                    if (ProjectInfo.TypeOfservices.includes("Repair")) { ProjectInfo.TypeOfservices = ProjectInfo.TypeOfservices.filter(a => a !== "Repair") } else { ProjectInfo.TypeOfservices.push("Repair") }
                                    console.log(ProjectInfo.TypeOfservices);
                                    setRender(a => !a)
                                }}
                            >
                                <div className="BookMainBoxTextCheckBoxCircle" style={ProjectInfo.TypeOfservices.includes("Repair") ? { "backgroundColor": "#0a65fc" } : { "backgroundColor": "white" }}></div>
                                <h3>Repair</h3>
                            </div>
                            {/* Bussiness */}
                            <div className="BookMainBoxTextCheckBox"
                                style={ProjectInfo.TypeOfservices.includes("Install") ? { "backgroundColor": "#f3f3f7" } : { "backgroundColor": "white" }}
                                onClick={() => {
                                    if (ProjectInfo.TypeOfservices.includes("Install")) { ProjectInfo.TypeOfservices = ProjectInfo.TypeOfservices.filter(a => a !== "Install") } else { ProjectInfo.TypeOfservices.push("Install") }
                                    console.log(ProjectInfo.TypeOfservices);
                                    setRender(a => !a)
                                }}
                            >
                                <div className="BookMainBoxTextCheckBoxCircle" style={ProjectInfo.TypeOfservices.includes("Install") ? { "backgroundColor": "#0a65fc" } : { "backgroundColor": "white" }}></div>
                                <h3>Install</h3>
                            </div>
                            {/* Bussiness */}
                            <div className="BookMainBoxTextCheckBox"
                                style={ProjectInfo.TypeOfservices.includes("Other") ? { "backgroundColor": "#f3f3f7" } : { "backgroundColor": "white" }}
                                onClick={() => {
                                    if (ProjectInfo.TypeOfservices.includes("Other")) { ProjectInfo.TypeOfservices = ProjectInfo.TypeOfservices.filter(a => a !== "Other") } else { ProjectInfo.TypeOfservices.push("Other") }
                                    console.log(ProjectInfo.TypeOfservices);
                                    setRender(a => !a)
                                }}
                            >
                                <div className="BookMainBoxTextCheckBoxCircle" style={ProjectInfo.TypeOfservices.includes("Other") ? { "backgroundColor": "#0a65fc" } : { "backgroundColor": "white" }}></div>
                                <h3>Other</h3>
                            </div>
                        </div>
                        <div className="BookMainBoxButtons">
                            <button className="BookMainBoxButtonsPrevius" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(3, false)
                            }}>Previus</button>
                            <button className="BookMainBoxButtonsNext" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(3, true)
                            }}>Next</button>
                        </div>

                    </div>
                </div>
                {/* Type Of Property */}
                <div className="BookMainPage">
                    <h1>What Kind of Location is This?</h1>
                    <div className="BookMainBox">
                        <h2>Is it Residential or Commercial?</h2>
                        <div className="BookMainBoxTextOptions">
                            {/* Residential */}
                            <div className="BookMainBoxTextOptionsBox"
                                style={ProjectInfo.TypeOfPropery == "Residential" ? { "backgroundColor": "#f3f3f7" } : { "backgroundColor": "white" }}
                                onClick={() => {
                                    ProjectInfo.TypeOfPropery = 'Residential'
                                    setRender(a => !a)
                                    console.log(ProjectInfo);
                                }}
                            >
                                <div className="BookMainBoxTextOptionsBoxCircle" style={ProjectInfo.TypeOfPropery == "Residential" ? { "backgroundColor": "#0a65fc" } : { "backgroundColor": "white" }}></div>
                                <h3>Residential</h3>
                            </div>
                            {/* Bussiness */}
                            <div className="BookMainBoxTextOptionsBox"
                                style={ProjectInfo.TypeOfPropery == "Commercial" ? { "backgroundColor": "#f3f3f7" } : { "backgroundColor": "white" }}
                                onClick={() => {
                                    ProjectInfo.TypeOfPropery = 'Commercial'
                                    setRender(a => !a)
                                    console.log(ProjectInfo);

                                }}
                            >
                                <div className="BookMainBoxTextOptionsBoxCircle" style={ProjectInfo.TypeOfPropery == "Commercial" ? { "backgroundColor": "#0a65fc" } : { "backgroundColor": "white" }}></div>
                                <h3>Commercial</h3>
                            </div>
                        </div>
                        <div className="BookMainBoxButtons">
                            <button className="BookMainBoxButtonsPrevius" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(4, false)
                            }}>Previus</button>
                            <button className="BookMainBoxButtonsNext" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(4, true)
                            }}>Next</button>
                        </div>

                    </div>
                </div>
                {/* When need the service? */}
                <div className="BookMainPage">
                    <h1>When do You Need This Done?</h1>
                    <div className="BookMainBox">
                        <h2>Choose the best window time</h2>
                        <h5>Choose Date</h5>
                        <div className="BookMainBoxTextInput">
                            <input
                                defaultValue={ProjectInfo.DateForProject}
                                type="date"
                                onChange={(e) => {
                                    ProjectInfo.DateForProject = e.target.value
                                    setRender(e => !e)
                                }}
                            />
                        </div>
                        <h5>Choose window time</h5>
                        <div className="BookMainBoxWindoTimeList">
                            {/* <div className="BookMainBoxWindoTimeListList"> */}
                            <div className="BookMainBoxWindoTimeListBox"
                                onClick={() => {
                                    ProjectInfo.WindowTime = "08:00AM-11:00AM"
                                    setRender(a => !a)
                                }}
                                style={
                                    ProjectInfo.WindowTime == "08:00AM-11:00AM" ?
                                        { "backgroundColor": "#0a65fc", "outline": "2px solid #0a65fc", "border": "2px solid white" }
                                        :
                                        { "backgroundColor": "#f3f7ff", "outline": "2px solid #f3f7ff", "border": "0px solid white" }
                                }
                            >
                                <img style={ProjectInfo.WindowTime == "08:00AM-11:00AM" ? { "filter": "invert()" } : null} src={require(`../../Images/location.png`)} />
                                <h3 style={ProjectInfo.WindowTime == "08:00AM-11:00AM" ? { "color": "white" } : null}>Morning</h3>
                                <h4 style={ProjectInfo.WindowTime == "08:00AM-11:00AM" ? { "color": "white" } : null}>8am-11am</h4>
                            </div>
                            <div className="BookMainBoxWindoTimeListBox"
                                onClick={() => {
                                    ProjectInfo.WindowTime = "11:00AM-02:00PM"
                                    setRender(a => !a)
                                }}
                                style={
                                    ProjectInfo.WindowTime == "11:00AM-02:00PM" ?
                                        { "backgroundColor": "#0a65fc", "outline": "2px solid #0a65fc", "border": "2px solid white" }
                                        :
                                        { "backgroundColor": "#f3f7ff", "outline": "2px solid #f3f7ff", "border": "0px solid white" }
                                }
                            >
                                <img style={ProjectInfo.WindowTime == "11:00AM-02:00PM" ? { "filter": "invert()" } : null} src={require(`../../Images/location.png`)} />
                                <h3 style={ProjectInfo.WindowTime == "11:00AM-02:00PM" ? { "color": "white" } : null}>Midday</h3>
                                <h4 style={ProjectInfo.WindowTime == "11:00AM-02:00PM" ? { "color": "white" } : null}>11am-2pm</h4>
                            </div>
                            {/* </div> */}
                            {/* <div className="BookMainBoxWindoTimeListList"> */}
                            <div className="BookMainBoxWindoTimeListBox"
                                onClick={() => {
                                    ProjectInfo.WindowTime = "02:00PM-05:00PM"
                                    setRender(a => !a)
                                }}
                                style={
                                    ProjectInfo.WindowTime == "02:00PM-05:00PM" ?
                                        { "backgroundColor": "#0a65fc", "outline": "2px solid #0a65fc", "border": "2px solid white" }
                                        :
                                        { "backgroundColor": "#f3f7ff", "outline": "2px solid #f3f7ff", "border": "0px solid white" }
                                }
                            >
                                <img style={ProjectInfo.WindowTime == "02:00PM-05:00PM" ? { "filter": "invert()" } : null} src={require(`../../Images/location.png`)} />
                                <h3 style={ProjectInfo.WindowTime == "02:00PM-05:00PM" ? { "color": "white" } : null}>Afternoon</h3>
                                <h4 style={ProjectInfo.WindowTime == "02:00PM-05:00PM" ? { "color": "white" } : null}>2pm-5pm</h4>
                            </div>
                            <div className="BookMainBoxWindoTimeListBox"
                                onClick={() => {
                                    ProjectInfo.WindowTime = "05:00PM-08:00PM"
                                    setRender(a => !a)
                                }}
                                style={
                                    ProjectInfo.WindowTime == "05:00PM-08:00PM" ?
                                        { "backgroundColor": "#0a65fc", "outline": "2px solid #0a65fc", "border": "2px solid white" }
                                        :
                                        { "backgroundColor": "#f3f7ff", "outline": "2px solid #f3f7ff", "border": "0px solid white" }
                                }
                            >
                                <img style={ProjectInfo.WindowTime == "05:00PM-08:00PM" ? { "filter": "invert()" } : null} src={require(`../../Images/location.png`)} />
                                <h3 style={ProjectInfo.WindowTime == "05:00PM-08:00PM" ? { "color": "white" } : null}>Evening</h3>
                                <h4 style={ProjectInfo.WindowTime == "05:00PM-08:00PM" ? { "color": "white" } : null}>After 5pm</h4>
                            </div>
                            {/* </div> */}

                        </div>
                        <div className="BookMainBoxButtons">
                            <button className="BookMainBoxButtonsPrevius" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(5, false)
                            }} >Previus</button>
                            <button className="BookMainBoxButtonsNext" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(5, true)
                            }}>Next</button>
                        </div>
                    </div>
                </div>
                {/* Tell us where? */}
                <div className="BookMainPage">
                    <h1>What's your project address?</h1>
                    <div className="BookMainBox">
                        <h2>Tell us where</h2>
                        {/* Address / Suit */}
                        <div className="BookMainBoxList">
                            <div className="BookMainBoxBox">
                                <h5>Address</h5>
                                <div className="BookMainBoxTextInput" style={Address ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                    <input type="text" name="" id="Address"
                                        defaultValue={ProjectInfo.Address}
                                        onChange={(e) => {
                                            ProjectInfo.Address = e.target.value
                                            setRender(a => !a)
                                        }}
                                    />
                                </div>
                                {Address ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid Address</h6> : null}

                            </div>
                            <div className="BookMainBoxBox">
                                <h5>Suit/Apt</h5>
                                <div className="BookMainBoxTextInput" >
                                    <input type="text" name="" id=""
                                        defaultValue={ProjectInfo.Apt}
                                        onChange={(e) => {
                                            ProjectInfo.Apt = e.target.value
                                            setRender(a => !a)
                                        }}
                                    />
                                </div>

                            </div>
                        </div>
                        {/* City */}
                        <div className="BookMainBoxBox">
                            <h5>City</h5>
                            <div className="BookMainBoxTextInput" style={City ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                <input type="text" name="" id=""
                                    defaultValue={ProjectInfo.City}
                                    onChange={(e) => {
                                        ProjectInfo.City = e.target.value
                                        setRender(a => !a)
                                    }}
                                />
                            </div>
                            {City ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid City</h6> : null}

                        </div>
                        {/* Zipcode */}
                        <div className="BookMainBoxBox">
                            <h5>Zipcode</h5>
                            <div className="BookMainBoxTextInput" style={Zipcode ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                <input
                                    type="number"
                                    inputMode="numeric"
                                    name="zipcode"
                                    id="zipcode"
                                    defaultValue={ZipCode}
                                    Value={ZipCode}
                                    onChange={(e) => {
                                        ProjectInfo.ZipCode = e.target.value
                                        setRender(a => !a)
                                        setUpdateApp(a => !a)
                                    }}
                                />
                            </div>
                            {Zipcode ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid Zipcode</h6> : null}
                        </div>

                        <div className="BookMainBoxButtons">
                            <button className="BookMainBoxButtonsPrevius" onClick={() => {
                                window.scrollTo(0, 0)
                                scrollRight(6, false)
                            }} >Previus</button>
                            <button className="BookMainBoxButtonsNext" onClick={() => {
                                if (!ProjectInfo.Address) { setAddress(true) } else { setAddress(false) }
                                if (!ProjectInfo.City) { setCity(true) } else { setCity(false) }
                                if (ProjectInfo.ZipCode.length == 5) { setZipcode(false) } else { setZipcode(true) }


                                if (ProjectInfo.Address && ProjectInfo.City && ProjectInfo.ZipCode.length == 5) {
                                    scrollRight(6, true)
                                    intervalFun(4);
                                    window.scrollTo(0, 0)
                                } else {
                                    return null
                                }
                            }}>Next</button>
                        </div>

                    </div>
                </div>
                {/* Building your project */}
                <div className="BookMainPage">
                    <h1>Building Your Project</h1>
                    <div className="BookMainBox">
                        <h2>Matching with HandyBy</h2>
                        <div className="BookMainBoxLodingBar">
                            <div className="BookMainBoxLodingBarCircle" style={
                                LoadingMatchingIndex == 1 ? { "width": "70px" } :
                                    LoadingMatchingIndex == 2 ? { "width": "180px" } :
                                        LoadingMatchingIndex == 3 ? { "width": "320px" } :
                                            LoadingMatchingIndex == 4 ? { "width": "100%" } : null
                            }></div>
                        </div>
                        <h5 style={{ 'textAlign': 'center' }}>{LoadingMatchingText[LoadingMatchingIndex]}...</h5>
                        <p>If this page does not redirect in 3 seconds, <span onClick={() => {
                            window.scrollTo(0, 0)
                            scrollRight(7, true)
                        }}>Click Here</span></p>
                    </div>
                </div>
                {/* Who you are? */}
                <div className="BookMainPage">
                    <h1>We have matching pros in your area!</h1>
                    <div className="CategoryReviewsConfirmed">
                        <img src={require(`../../Images/verifed.png`)} alt="Chimney Cleaning" />
                        <h2>We matched approved {ProjectInfo.Service == "New Project" ? "and certifed" : ProjectInfo.Service} pro to do the job for you!</h2>
                    </div>
                    <div className="BookMainBox">
                        <h2>Tell us about you</h2>
                        {/* First and Last Name */}
                        <div className="BookMainBoxList2">
                            <div className="BookMainBoxBox">
                                <h5>First Name</h5>
                                <div className="BookMainBoxTextInput" style={FirstName ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                    <input type="text" name="" id=""
                                        defaultValue={ProjectInfo.FirstName}
                                        onChange={(e) => {
                                            ProjectInfo.FirstName = e.target.value
                                            setRender(a => !a)
                                        }}
                                    />
                                </div>
                                {FirstName ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid First Name</h6> : null}

                            </div>
                            <div className="BookMainBoxBox" >
                                <h5>Last Name</h5>
                                <div className="BookMainBoxTextInput" style={LastName ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                    <input type="text" name="" id=""
                                        defaultValue={ProjectInfo.LastName}
                                        onChange={(e) => {
                                            ProjectInfo.LastName = e.target.value
                                            setRender(a => !a)
                                        }}
                                    />
                                </div>
                                {LastName ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid Last Name</h6> : null}

                            </div>
                        </div>
                        {/* Phone */}
                        <div className="BookMainBoxBox">
                            <h5>Phone</h5>
                            <div className="BookMainBoxTextInput" style={PhoneNumber ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                <input type="tel" name="" id=""
                                    defaultValue={ProjectInfo.PhoneNumber}
                                    onChange={(e) => {
                                        ProjectInfo.PhoneNumber = e.target.value
                                        setRender(a => !a)
                                    }}
                                />
                            </div>
                            {PhoneNumber ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid Phone Number</h6> : null}

                        </div>
                        {/* Email */}
                        <div className="BookMainBoxBox">
                            <h5>Email</h5>
                            <div className="BookMainBoxTextInput" style={Email ? { "outline": "2px solid #fc0a0a" } : { "outline": "unset" }}>
                                <input type="text" name="" id=""
                                    defaultValue={ProjectInfo.Email}
                                    onChange={(e) => {
                                        ProjectInfo.Email = e.target.value
                                        setRender(a => !a)
                                    }}
                                />
                            </div>
                            {Email ? <h6 style={{ "color": "#fc0a0a", "textAlign": "start" }}>Please enter a valid Email</h6> : null}

                        </div>

                        <div className="BookMainBoxSignUpEmail">
                            <div className="BookMainBoxSignUpEmailCheckbox"></div>
                            <h5>Sign up to get free project cost info in your inbox..</h5>
                        </div>

                        <div className="BookMainBoxButtons">
                            {!LoadingProject ?
                                <form className="contact-form" onSubmit={CreateProject}>
                                    <input type="hidden" name="from_name" defaultValue={FinalMessage} />
                                    <input type="hidden" name="Company" defaultValue={`HandyBy.com | ${ProjectInfo.City} | ${ProjectInfo.Service}`} />
                                    <input type="submit" value="Request Service" className="BookMainBoxButtonsNext" />
                                </form>
                                :
                                <div className="BookMainBoxButtonsLoading">
                                    <img src={require(`../../Images/loading.png`)} alt="Chimney Cleaning" />
                                </div>
                            }
                        </div>
                        <h6>By clicking Request Service Pros, I agree to HandyBy's Terms and Privacy Policy, and that Angi and its service professionals, or parties acting on their behalf, may use automated technology and prerecorded messages to deliver marketing calls or texts regarding my project and future projects to the number I provided. Consent is not a condition of service.</h6>
                    </div>
                </div>
                {/* What Next? */}
                <div className="BookMainPage">
                    <h1>Next up: Your Service Request <br /> Was Successfully Submitted!</h1>

                    <div className="BookMainBoxWhatNext">
                        <div className="BookMainBoxWhatNextLeft">
                            <h2>Here’s what’s next</h2>
                            <h3><img src={require(`../../Images/business.png`)} />This is a free consultation — no commitment until you and the Pro agree on the price. If you both approve, the Pro can start right away.</h3>
                            <h4> <img src={require(`../../Images/tick.png`)} /> Pre-screened, trusted contractors</h4>
                            <h4> <img src={require(`../../Images/tick.png`)} /> No hidden fees — transparent pricing</h4>
                            <h4> <img src={require(`../../Images/tick.png`)} /> Quick same-day or next-day service</h4>
                            <h4> <img src={require(`../../Images/tick.png`)} /> Only pay when you approve the work</h4>
                        </div>
                        <div className="CategoryReviewsConfirmed">
                            <img src={require(`../../Images/verifed.png`)} />
                            <h2>A local HandyBy pro will call you 30 minutes before your appointment to let you know they are on the way.</h2>
                        </div>
                    </div>
                    <div className="BookMainBoxWhatNextLine"></div>
                    <div className="BookMainBoxButtons">
                        <a className="BookMainBoxButtonsNext" href={UserSession && UserSession.FirstName ? '/account/projects' : '/my-projects'} >View my project details</a>
                    </div>
                    <div className="MenuMainSubFooter" >
                        <h1>Create another project in seconds.</h1>
                        <h2>Need help with something else? Besides {ProjectInfo.Service}, We offer a wide range of home services.</h2>
                        <div className="MenuMainSubFooterList">

                            <a href="/category/Chimney-Fireplace" className="MenuMainSubFooterBox">
                                <img src={require(`../../Images/1-chimney.jpg`)} />
                                <h1>Chimney Sweep</h1>
                            </a>
                            <a href="/category/Garage-Door" className="MenuMainSubFooterBox">
                                <img src={require(`../../Images/1-garage.jpg`)} />
                                <h1>Garage Door</h1>
                            </a>
                            <a href="/category/Locksmith" className="MenuMainSubFooterBox">
                                <img src={require(`../../Images/1-locksmith.jpg`)} />
                                <h1>Locksmith</h1>
                            </a>
                            <a href="/category/Roofing" className="MenuMainSubFooterBox">
                                <img src={require(`../../Images/1-roofing.jpg`)} />
                                <h1>Roofing</h1>
                            </a>
                            <a href="/category/Air-Duct" className="MenuMainSubFooterBox">
                                <img src={require(`../../Images/1-airduct.jpg`)} />
                                <h1>Air Duct</h1>
                            </a>
                            <a href="/category/Dryer-Vent" className="MenuMainSubFooterBox">
                                <img src={require(`../../Images/1-dryervent.jpg`)} />
                                <h1>Dryer Vent</h1>
                            </a>
                            <a href="/category/HVAC" className="MenuMainSubFooterBox">
                                <img src={require(`../../Images/1-hvac.jpg`)} />
                                <h1>HVAC</h1>
                            </a>
                            <a href="/category/Insulation" className="MenuMainSubFooterBox">
                                <img src={require(`../../Images/1-insulation.jpg`)} />
                                <h1>Insulation</h1>
                            </a>
                            <a href="/start-project" className="MenuMainSubFooterBoxLast">
                                View All Services
                            </a>
                        </div>
                        <a href="/start-project">Don’t see what you’re looking for? View All</a>
                    </div>
                </div>
            </div>
            <div className="BookFooter">
                <div className="BookFooterLeft">
                    <h2>© 1995-2025, HandyBy. All Rights Reserved.</h2>
                </div>
                <div className="BookFooterRight">
                    <a href="">Terms of Use</a>
                    <a href="">Privacy Policy</a>
                    <a href="">Do Not Sell</a>
                </div>
            </div>
            {
                ShowHowisWork ?
                    <div className="CategoryHowMatchWork">
                        <div className="CategoryHowMatchWorkBoxDark" onClick={() => {
                            setclosMenuAnime(true)
                            setRender(a => !a)
                            setTimeout(() => {
                                setShowHowisWork(false)
                                setclosMenuAnime(false)

                            }, 300);
                        }}></div>
                        <div className={closMenuAnime ? "CategoryHowMatchWorkMain CategoryHowMatchWorkMainAnime" : "CategoryHowMatchWorkMain"} >
                            <h1>How HandyBy Work?</h1>
                            <img className="CategoryHowMatchWorkMainClose" src={require(`../../Images/closeMenu.png`)} onClick={() => {
                                setclosMenuAnime(true)
                                setRender(a => !a)
                                setTimeout(() => {
                                    setShowHowisWork(false)
                                    setclosMenuAnime(false)

                                }, 300);
                            }} />

                            <div className="CategoryHowMatchWorkList" ref={containerRef2}>
                                <div className="CategoryHowMatchWorkBox">
                                    <div className="CategoryHowMatchWorkBoxBox1">
                                        <div className="CategoryHowMatchWorkBoxBox1Back">
                                            <h2>Create a Project</h2>
                                            <h3>Find a qualified pro for the exact service you’re looking for :)</h3>
                                            <h4>Roofing contractor near me |</h4>
                                        </div>
                                    </div>
                                    <h2>Tell Us What You Need</h2>
                                    <h3>Submit a quick project request with the service you’re looking for.</h3>
                                    <a onClick={() => scrollRightHowItWork(1, true, "-20px")}>Next</a>

                                </div>
                                <div className="CategoryHowMatchWorkBox">
                                    <div className="CategoryHowMatchWorkBoxBox2">
                                        <h4>You have new project</h4>
                                        <img className="" src={require(`../../Images/howitwork2.png`)} />
                                    </div>
                                    <h2>Get Matched with a HandyBy Pro</h2>
                                    <h3>We connect you with a qualified, local contractor who can get it done.</h3>
                                    <a onClick={() => scrollRightHowItWork(2, true, "40px")}>Next</a>

                                </div>
                                <div className="CategoryHowMatchWorkBox">
                                    <div className="CategoryHowMatchWorkBoxBox3">
                                        <img className="" src={require(`../../Images/contractorProfile.jpeg`)} />
                                        <h4>🚘 &nbsp; A HandyBy Pro Is On The Way...</h4>
                                    </div>
                                    <h2>Post your task</h2>
                                    <h3>Your HandyBy Pro shows up ready to work. Work only starts once you both agree on the price.</h3>
                                    <a onClick={() => {
                                        setclosMenuAnime(true)
                                        setRender(a => !a)
                                        setTimeout(() => {
                                            setShowHowisWork(false)
                                            setclosMenuAnime(false)

                                        }, 300);
                                    }}>Handy Me Now!</a>

                                </div>
                            </div>
                        </div>

                    </div>
                    : null
            }
        </div >
    )
}

